import { subscribeOnStream, unsubscribeFromStream } from '../streaming/SingalRStreaming.js';
import {
    sortBars,
    getConvertedTradingTimes,
    getHistoricalData, getAllSymbols
} from "../helpers.js"
import * as config from '../../../config.js';
import { getHistoricalDateByScrollIndex, WaveformatAndEncodeDate } from '../time_helper.js';

var allSymbols = null;
const lastBarsCache = new Map();

const scrollDepth = new Map();




const configurationData = {
    supports_search: false,
    supports_group_request: config.supports_group_request,
    supports_marks: config.supports_marks,
    supports_timescale_marks: config.supports_timescale_marks,
    supports_time: config.supports_time,
    has_intraday: config.has_intraday,
    has_daily: config.has_daily,
    has_weekly_and_monthly: config.has_weekly_and_monthly,
    supported_resolutions: config.supported_resolutions,
    intraday_multipliers: config.intraday_multipliers,
    daily_multipliers: config.daily_multipliers,
    weekly_multipliers: config.weekly_multipliers,
    monthly_multipliers: config.monthly_multipliers,
    exchanges: config.exchanges,
    symbols_types: config.symbols_types
};

const waveSingalRDatafeed = {
    onReady: async (callback) => {
        allSymbols = await getAllSymbols();
        if (allSymbols === null) return null;
        setTimeout(() => callback(configurationData));
    },
    searchSymbols: async (userInput, exchange, _, onResultReadyCallback) => {
        const newSymbols = allSymbols.filter(symbol => {
            const isExchangeValid = exchange === '';
            const isFullSymbolContainsInput = symbol.full_name
                .toLowerCase()
                .indexOf(userInput.toLowerCase()) !== -1;
            return isExchangeValid && isFullSymbolContainsInput;
        });
        onResultReadyCallback(newSymbols);
    },
    resolveSymbol: async (symbolName, onSymbolResolvedCallback, onResolveErrorCallback, extension) => {
        let symbolData = null;


        if (allSymbols) {
            allSymbols.forEach(element => {
                if (element.symbol.toLowerCase() === symbolName.toLowerCase() || element.full_name === symbolName) {
                    symbolData = element
                }
            });
        }
        let session = "24x7";
        const cleanSymbol = symbolData.symbol.replace("#", "");

        if (symbolData.tradeFrom && symbolData.tradeTo) {
            try {
                session = getConvertedTradingTimes(symbolData.tradeFrom, symbolData.tradeTo);
            } catch (err) {
                console.warn("[Session Parser] Invalid trade times for:", cleanSymbol, err);
            }
        }
        setTimeout(() => {
            const symbolInfo = {
                id:symbolData.id,
                ticker: cleanSymbol,
                name: cleanSymbol,
                token_name: cleanSymbol,
                description: symbolData.full_name,
                type: "forex",
                session: session,
                timezone: 'Etc/UTC',
                exchange: "",
                minmov: 1,
                pricescale: 100000,
                has_intraday: true,
                visible_plots_set: 'ohlc',
                has_weekly_and_monthly: false,
                supported_resolutions: configurationData.supported_resolutions,
                volume_precision: 6,
                data_status: 'streaming',
            };
            onSymbolResolvedCallback(symbolInfo);
        }, 0);
    },
    getBars: async (symbolInfo, resolution, periodParams, onHistoryCallback, onErrorCallback) => {
    try {
        const symbol = symbolInfo.token_name.replace("#", "");
        if (periodParams.firstDataRequest) {
            scrollDepth.set(symbol, 0);
        }

        const scrollIndex = scrollDepth.get(symbol) || 0;

        const { fromDate, toDate } = getHistoricalDateByScrollIndex(scrollIndex);
        const now = new Date();
        fromDate.setHours(now.getHours(), now.getMinutes(), now.getSeconds(), 0);
        toDate.setHours(now.getHours(), now.getMinutes(), now.getSeconds(), 0);

        const fromEncoded = WaveformatAndEncodeDate(fromDate);
        const toEncoded = WaveformatAndEncodeDate(toDate);
        const receivedBars = await getHistoricalData(symbol, fromEncoded, toEncoded);

        const mappedReceivedBars = receivedBars.map(bar => ({
            time: new Date(bar.date).getTime(),
            open: bar.open,
            high: bar.high,
            low: bar.low,
            close: bar.close
        }));

        await sortBars(mappedReceivedBars);

        if (mappedReceivedBars.length > 0) {
            lastBarsCache.set(symbolInfo.full_name, mappedReceivedBars[mappedReceivedBars.length - 1]);
            onHistoryCallback(mappedReceivedBars, { noData: false });
            scrollDepth.set(symbol, scrollIndex + 1);
        } else {
            onHistoryCallback([], { noData: true });
        }
    } catch (err) {
        console.error("[getBars] Error:", err);
        onErrorCallback(err);
    }
},


    subscribeBars: (symbolInfo, resolution, onRealtimeCallback, subscriberUID, onResetCacheNeededCallback) => {
        subscribeOnStream(
            symbolInfo,
            resolution,
            onRealtimeCallback,
            subscriberUID,
            onResetCacheNeededCallback,
            lastBarsCache.get(symbolInfo.full_name)
        );
    },
    unsubscribeBars: (subscriberUID) => {
        unsubscribeFromStream(subscriberUID);
    }
};

export default waveSingalRDatafeed;